import React from 'react';

function PathArrow() {
  return (
    <svg width="5" height="8">
      <path
        d="M4.929 4.21c.116-.218.093-.436-.094-.588L.893.137a.547.547 0 00-.747.021.464.464 0 00.024.697L3.716 3.97.17 7.15a.483.483 0 00-.024.698C.24 7.956.403 8 .543 8s.256-.044.373-.13l3.92-3.53s0-.021.023-.021l.023-.022c.023-.022.023-.065.047-.087"
        fill="#9B9B9B"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default PathArrow;
